import {
  ClampJointAdditionalMaterial,
  ClampJointCountSettings,
  ClampJointTypeEnum,
} from '../../user/cutting-settings.model';
import { CuttingMaterial } from '../cutting-material.model';
import { Cutout, FaceBand } from '../cutting-panel-outline.model';
import {
  CountertopLinesJointTypeEnum,
  CountertopTypeEnum,
  GShapedCountertopSubtypeEnum,
  PShapedCountertopSubtypeEnum,
} from './countertop.interface';
import { CountertopEdgeBanding, CountertopFastenersSet, CountertopHole, CountertopSlot } from './outline';
import { CountertopAngleProcessingBase } from './outline/countertop-angle-processing.interface';

export interface CountertopRequest {
  type: CountertopTypeEnum;
  subtype?: PShapedCountertopSubtypeEnum | GShapedCountertopSubtypeEnum;

  materials: CuttingMaterial[];

  has3d: boolean;

  length: number;

  width: number;

  lines: CountertopLineRequest[];
  linesJoints?: CountertopLinesJointRequest[];

  outline: CountertopOutlineRequest;
}

export interface CountertopLineRequest {
  uid: string;
  materialId: number;
  panels: CountertopPanelRequest[];

  panelsJoints: CountertopPanelsJointRequest[];

  length: number;
  width: number;
}

export interface CountertopPanelsJointRequest {
  panel1Uid: string;
  panel2Uid: string;
  connector: ClampJointRequest | null;
}

export interface CountertopPanelRequest {
  uid: string;

  length: number;
  width: number;
}

export interface ClampJointRequest {
  type: ClampJointTypeEnum;
  l: number;
  l2: number;
  h: number;
  b: number;
  d: number;
  additionalMaterials: ClampJointAdditionalMaterial[];
  minMaterialThickness: number;
  maxMaterialThickness: number;
  edgeOffset: number;
  countSettings: ClampJointCountSettings[];
  count: number;
  nameOfGrooveRecess: string;
  designationOfGrooveRecess: string;
}

export interface CountertopLinesJointRequest {
  line1Uid: string;
  line2Uid: string;
  line1Type: CountertopJointLineTypeRequestEnum;
  line2Type: CountertopJointLineTypeRequestEnum;
  type: CountertopLinesJointTypeEnum;
  length: number;
  parameters: MasonsMitreJointParamsRequest | null;
  connector: ClampJointRequest | null;
}

export interface MasonsMitreJointParamsRequest {
  radius: number;
  allowance: number;
}

export interface CountertopOutlineRequest {
  customHoles: CountertopHoleRequest[];
  fastenersSets: CountertopFastenersSetRequest[];
  angleProcessing: CountertopAngleProcessingBase[];
  edgeBanding: CountertopEdgeBanding[];
  faceBanding: FaceBand[];
  slots: CountertopSlot[];
  cutouts: Cutout[];
}

export interface CountertopFastenersSetRequest extends Omit<CountertopFastenersSet, 'position'> {
  position: CountertopOutlineSideRequestEnum;
}

export interface CountertopHoleRequest extends Omit<CountertopHole, 'position'> {
  position: CountertopOutlineSideRequestEnum;
}

export enum CountertopJointLineTypeRequestEnum {
  None,
  Male,
  Female,
}

export enum CountertopOutlineSideRequestEnum {
  Top,
  Right,
  Bottom,
  Left,
}
